const DEFAULT_GAME_CARD_SIZES = {
	"1x1": {
		width: "136px",
		height: "106px",
		tabletWidth: "170px",
		tabletHeight: "140px",
		wideDesktopWidth: "170px",
		wideDesktopHeight: "140px",
		overlayWidth: "100%",
		overlayHeight: "106px",
		overlayWideDesktopWidth: "170px",
		overlayWideDesktopHeight: "140px",
	},
	"2x1": {
		width: "282px",
		height: "106px",
		tabletWidth: "350px",
		tabletHeight: "140px",
		wideDesktopWidth: "350px",
		wideDesktopHeight: "140px",
		overlayWidth: "100%",
		overlayHeight: "106px",
		overlayWideDesktopWidth: "350px",
		overlayWideDesktopHeight: "140px",
	},
	"1x2": {
		width: "136px",
		height: "252px",
		tabletWidth: "170px",
		tabletHeight: "320px",
		wideDesktopWidth: "170px",
		wideDesktopHeight: "320px",
		overlayWidth: "100%",
		overlayHeight: "252px",
		overlayWideDesktopWidth: "170px",
		overlayWideDesktopHeight: "320px",
	},
	"4x5": {
		width: "136px",
		height: "170px",
		tabletWidth: "170px",
		tabletHeight: "213px",
		wideDesktopWidth: "170px",
		wideDesktopHeight: "213px",
		overlayWidth: "100%",
		overlayHeight: "170px",
		overlayWideDesktopWidth: "170px",
		overlayWideDesktopHeight: "213px",
	},
	"2x2": {
		width: "282px",
		height: "252px",
		tabletWidth: "350px",
		tabletHeight: "320px",
		wideDesktopWidth: "350px",
		wideDesktopHeight: "320px",
		overlayWidth: "100%",
		overlayHeight: "252px",
		overlayWideDesktopWidth: "350px",
		overlayWideDesktopHeight: "320px",
	},
};

const CHOKWIN_GAME_CARD_SIZES = {
	"1x1": {
		width: "140px",
		height: "80px",
		tabletWidth: "140px",
		tabletHeight: "80px",
		wideDesktopWidth: "140px",
		wideDesktopHeight: "80px",
		overlayWidth: "100%",
		overlayHeight: "80px",
		overlayWideDesktopWidth: "140px",
		overlayWideDesktopHeight: "80px",
	},
	"2x1": {
		width: "290px",
		height: "80px",
		tabletWidth: "290px",
		tabletHeight: "80px",
		wideDesktopWidth: "290px",
		wideDesktopHeight: "80px",
		overlayWidth: "100%",
		overlayHeight: "80px",
		overlayWideDesktopWidth: "290px",
		overlayWideDesktopHeight: "80px",
	},
	"1x2": {
		width: "140px",
		height: "190px",
		tabletWidth: "140px",
		tabletHeight: "190px",
		wideDesktopWidth: "140px",
		wideDesktopHeight: "190px",
		overlayWidth: "100%",
		overlayHeight: "190px",
		overlayWideDesktopWidth: "140px",
		overlayWideDesktopHeight: "190px",
	},
	"4x5": {
		width: "140px",
		height: "175px",
		tabletWidth: "140px",
		tabletHeight: "175px",
		wideDesktopWidth: "140px",
		wideDesktopHeight: "175px",
		overlayWidth: "100%",
		overlayHeight: "175px",
		overlayWideDesktopWidth: "140px",
		overlayWideDesktopHeight: "175px",
	},
	"2x2": {
		width: "290px",
		height: "190px",
		tabletWidth: "290px",
		tabletHeight: "190px",
		wideDesktopWidth: "290px",
		wideDesktopHeight: "190px",
		overlayWidth: "100%",
		overlayHeight: "190px",
		overlayWideDesktopWidth: "290px",
		overlayWideDesktopHeight: "190px",
	},
};

const BETTO_GAME_CARD_SIZES = {
	"1x1": {
		width: "200px",
		height: "250px",
		tabletWidth: "200px",
		tabletHeight: "250px",
		wideDesktopWidth: "200px",
		wideDesktopHeight: "250px",
		overlayWidth: "100%",
		overlayHeight: "250px",
		overlayWideDesktopWidth: "200px",
		overlayWideDesktopHeight: "250px",
	},
	"2x1": {
		width: "400px",
		height: "250px",
		tabletWidth: "400px",
		tabletHeight: "250px",
		wideDesktopWidth: "400px",
		wideDesktopHeight: "250px",
		overlayWidth: "100%",
		overlayHeight: "250px",
		overlayWideDesktopWidth: "400px",
		overlayWideDesktopHeight: "250px",
	},
	"1x2": {
		width: "200px",
		height: "500px",
		tabletWidth: "200px",
		tabletHeight: "500px",
		wideDesktopWidth: "200px",
		wideDesktopHeight: "500px",
		overlayWidth: "100%",
		overlayHeight: "500px",
		overlayWideDesktopWidth: "200px",
		overlayWideDesktopHeight: "500px",
	},
	"4x5": {
		width: "200px",
		height: "250px",
		tabletWidth: "200px",
		tabletHeight: "250px",
		wideDesktopWidth: "200px",
		wideDesktopHeight: "250px",
		overlayWidth: "100%",
		overlayHeight: "250px",
		overlayWideDesktopWidth: "200px",
		overlayWideDesktopHeight: "250px",
	},
	"2x2": {
		width: "400px",
		height: "500px",
		tabletWidth: "400px",
		tabletHeight: "500px",
		wideDesktopWidth: "400px",
		wideDesktopHeight: "500px",
		overlayWidth: "100%",
		overlayHeight: "500px",
		overlayWideDesktopWidth: "400px",
		overlayWideDesktopHeight: "500px",
	},
};

export const getTenantCardSizes = () => {
	const tenant = window.TENANT;

	if (tenant === "chokwin") {
		return CHOKWIN_GAME_CARD_SIZES;
	}

	if (tenant === "betto") {
		return BETTO_GAME_CARD_SIZES;
	}

	return DEFAULT_GAME_CARD_SIZES;
};
